import React from 'react';
import Styles from '@src/framework/editor/src/page/index/components/editor/index.less';

/**
 * 悬挂工具栏下拉菜单中的按钮列表项
 */
interface DropDownItemProps {
    item: {
        id: string;
        name?: string;
    };
    index: number;
    selectedIndex: number;
    onSelectedItemCallback: (id: string, index: number) => void;
}

export default class DropDownItem extends React.Component<DropDownItemProps> {
    public render() {
        const { item } = this.props;
        const isSelected = this.props.selectedIndex === this.props.index;
        const selectedClassName = isSelected
            ? `${Styles[`link-floatbar-v2-dropdown-item-icon-${item.id}`]} ${Styles['link-floatbar-v2-dropdown-item-selected']}`
            : `${Styles[`link-floatbar-v2-dropdown-item-icon-${item.id}`]}`;
        return (
            <li className={Styles['link-floatbar-v2-dropdown-item']}
                onMouseUp={this.onMouseUp}
            >
                {item.name && item.name.length > 0
                    ? <div className={Styles['link-floatbar-v2-dropdown-item-content']}>
                        <div className={selectedClassName}/>
                        {item.name}
                    </div> : ''}
            </li>
        );
    }
    private onMouseUp = () => {
        this.props.onSelectedItemCallback(this.props.item.id, this.props.index);
    };
}
